import { Injectable } from '@angular/core';
import { ApplicationHttpClient } from '../../shared/api/application-http-client';
import { IPermissions } from './teacher-profile.interface';

@Injectable({
  providedIn: 'root'
})
export class TeacherProfileService {

  constructor(private httpClient: ApplicationHttpClient) {}

  getUserPermissions(userId: number) {
    return this.httpClient.get(`/user/permissions/${userId}`);
  }

  updatePermissions(data: IPermissions) {
    return this.httpClient.put('/user/permissions', data);
  }

  getTimezone() {
    return this.httpClient.get('/timezones');
  }

  updateTimezone(timeZone: string) {
    return this.httpClient.put(`/school/timezone?timeZone=${timeZone}`, {});
  }
}

